import { watch } from '@vue/composition-api'
import { noop } from 'lodash'

export default ({
  valueOrFunction,
  callback
}) => {
  let clean = null
  if (typeof valueOrFunction === 'function') {
    clean = watch(
      valueOrFunction,
      value => {
        callback(value)
      }, {
        immediate: true,
        deep: true
      }
    )
  } else {
    callback(valueOrFunction)
  }
  return clean || noop
}
